import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'cpui-animated-clouds',
  templateUrl: './animated-clouds.component.html',
  styleUrls: ['./animated-clouds.component.scss']
})
export class AnimatedCloudsComponent implements OnInit {
  isReady = false;

  constructor() {
  }

  ngOnInit() {
    setTimeout(() => this.isReady = true, 500);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/animated-clouds/animated-clouds.component.ts